var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDeleteImage = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99992 12.6667C3.99992 13.4 4.59992 14 5.33325 14H10.6666C11.3999 14 11.9999 13.4 11.9999 12.6667V6C11.9999 5.26667 11.3999 4.66667 10.6666 4.66667H5.33325C4.59992 4.66667 3.99992 5.26667 3.99992 6V12.6667ZM11.9999 2.66667H10.3333L9.85992 2.19333C9.73992 2.07333 9.56659 2 9.39325 2H6.60659C6.43325 2 6.25992 2.07333 6.13992 2.19333L5.66659 2.66667H3.99992C3.63325 2.66667 3.33325 2.96667 3.33325 3.33333C3.33325 3.7 3.63325 4 3.99992 4H11.9999C12.3666 4 12.6666 3.7 12.6666 3.33333C12.6666 2.96667 12.3666 2.66667 11.9999 2.66667Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/deleteImage.0e9e98a3.svg";
export { ForwardRef as ReactComponent };